/*
 * Copyright (c) CIRROM 2024.
 */

import { API } from "./api";

export const getAllAccountNames = async (
  systemId: number
): Promise<{ crm_account_id: string; name: string }[]> => {
  //Get a list of all currently configured data loader systems
  const response = await API.get("/get-account-names", {
    params: { integrated_system_id: systemId },
  });
  return response.data;
};
